import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
	providedIn: 'root'
})
export class AppearancePreferenceService {

	private readonly SCALE_LAYOUT_STORAGE_KEY: string = 'ui.scale-layout.enabled';
	private readonly SIDEBAR_FAVORITES_STORAGE_KEY: string = 'ui.sidebar-favorites.enabled';
	private readonly SIDEBAR_COMMUNITY_STORAGE_KEY: string = 'ui.sidebar-community.enabled';
	private readonly FULL_SCREEN_STORAGE_KEY: string = 'ui.full-screen.enabled';
	private readonly SCALE_LAYOUT_DEFAULT_ENABLED: boolean = false;
	private readonly SIDEBAR_FAVORITES_DEFAULT_ENABLED: boolean = true;
	private readonly SIDEBAR_COMMUNITY_DEFAULT_ENABLED: boolean = true;
	private readonly FULL_SCREEN_DEFAULT_ENABLED: boolean = false;
	private readonly scaleLayoutEnabledSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
		this.loadPreference(this.SCALE_LAYOUT_STORAGE_KEY, this.SCALE_LAYOUT_DEFAULT_ENABLED)
	);
	private readonly sidebarFavoritesEnabledSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
		this.loadPreference(this.SIDEBAR_FAVORITES_STORAGE_KEY, this.SIDEBAR_FAVORITES_DEFAULT_ENABLED)
	);
	private readonly sidebarCommunityEnabledSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
		this.loadPreference(this.SIDEBAR_COMMUNITY_STORAGE_KEY, this.SIDEBAR_COMMUNITY_DEFAULT_ENABLED)
	);
	private readonly fullScreenEnabledSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
		this.loadPreference(this.FULL_SCREEN_STORAGE_KEY, this.FULL_SCREEN_DEFAULT_ENABLED)
	);

	readonly scaleLayoutEnabled$: Observable<boolean> = this.scaleLayoutEnabledSubject.asObservable();
	readonly sidebarFavoritesEnabled$: Observable<boolean> = this.sidebarFavoritesEnabledSubject.asObservable();
	readonly sidebarCommunityEnabled$: Observable<boolean> = this.sidebarCommunityEnabledSubject.asObservable();
	readonly fullScreenEnabled$: Observable<boolean> = this.fullScreenEnabledSubject.asObservable();


	setScaleLayoutEnabled(isEnabled: boolean): void {
		this.savePreference(this.SCALE_LAYOUT_STORAGE_KEY, isEnabled, this.scaleLayoutEnabledSubject);
	}

	setSidebarFavoritesEnabled(isEnabled: boolean): void {
		this.savePreference(this.SIDEBAR_FAVORITES_STORAGE_KEY, isEnabled, this.sidebarFavoritesEnabledSubject);
	}

	setSidebarCommunityEnabled(isEnabled: boolean): void {
		this.savePreference(this.SIDEBAR_COMMUNITY_STORAGE_KEY, isEnabled, this.sidebarCommunityEnabledSubject);
	}

	setFullScreenEnabled(isEnabled: boolean): void {
		this.savePreference(this.FULL_SCREEN_STORAGE_KEY, isEnabled, this.fullScreenEnabledSubject);
	}

	resetToDefaults(): void {
		this.scaleLayoutEnabledSubject.next(this.SCALE_LAYOUT_DEFAULT_ENABLED);
		this.sidebarFavoritesEnabledSubject.next(this.SIDEBAR_FAVORITES_DEFAULT_ENABLED);
		this.sidebarCommunityEnabledSubject.next(this.SIDEBAR_COMMUNITY_DEFAULT_ENABLED);
		this.fullScreenEnabledSubject.next(this.FULL_SCREEN_DEFAULT_ENABLED);
	}

	private loadPreference(storageKey: string, defaultValue: boolean): boolean {
		const storedValue: string | null = localStorage.getItem(storageKey);
		return storedValue === null ? defaultValue : storedValue === 'true';
	}

	private savePreference(storageKey: string, isEnabled: boolean, subject: BehaviorSubject<boolean>): void {
		localStorage.setItem(storageKey, String(isEnabled));
		subject.next(isEnabled);
	}
}
